class CartDrawer {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.updateCartCount();
    
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

class ProductForm {
  constructor(form) {
    this.form = form;
    this.init();
  }

  init() {
    if (!this.form) return;
    
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    const submitButton = this.form.querySelector('[type="submit"]');
    const originalText = submitButton.textContent;
    const variantId = this.form.querySelector('#product-variant-id').value;
    
    if (!variantId) {
      alert('商品のバリエーションを選択してください。');
      return;
    }
    
    submitButton.disabled = true;
    submitButton.textContent = '追加中...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: parseInt(variantId),
          quantity: 1
        })
      });
      
      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        // Si le parsing JSON échoue mais que la réponse est OK, vérifier le panier
        if (response.ok) {
          // Vérifier si l'article a été ajouté en consultant le panier
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          if (cart.item_count > 0) {
            submitButton.textContent = '追加しました！';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              window.location.href = window.routes.cart_url;
            }, 500);
            return;
          }
        }
        throw new Error('Failed to parse response');
      }
      
      // Shopify retourne un objet avec 'items' en cas de succès, ou 'description' en cas d'erreur
      if (data.description || data.message) {
        // Erreur retournée par Shopify
        throw new Error(data.description || data.message || 'Failed to add to cart');
      }
      
      // Succès - l'article a été ajouté (même si response.ok est false, si pas d'erreur dans data, c'est OK)
      submitButton.textContent = '追加しました！';
      
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      setTimeout(() => {
        window.location.href = window.routes.cart_url;
      }, 500);
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      submitButton.textContent = originalText;
      submitButton.disabled = false;
      
      // Vérifier si l'article a quand même été ajouté malgré l'erreur
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        if (cart.item_count > 0) {
          // Le panier contient des articles, donc l'ajout a probablement réussi malgré l'erreur
          submitButton.textContent = '追加しました！';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(() => {
            window.location.href = window.routes.cart_url;
          }, 500);
          return;
        }
      } catch (checkError) {
        // Ignorer l'erreur de vérification
      }
      
      // Afficher l'erreur seulement si l'article n'a vraiment pas été ajouté
      alert('カートに商品を追加できませんでした。もう一度お試しください。\n' + (error.message || ''));
    }
  }
}

// Archive routing handler - solution de secours si Liquid ne détecte pas le paramètre
class ArchiveRouter {
  constructor() {
    this.init();
  }

  init() {
    // Vérifier si on est sur la page archive avec un paramètre product
    if (window.location.pathname === '/pages/archive') {
      const urlParams = new URLSearchParams(window.location.search);
      const productHandle = urlParams.get('product');
      
      if (productHandle) {
        // Vérifier si la page de détail est affichée
        const archiveDetail = document.querySelector('.archive-detail-page');
        const archiveList = document.querySelector('.archive-page');
        
        // Si on a le paramètre mais que la liste est affichée au lieu du détail
        if (archiveList && !archiveDetail) {
          // Forcer le rechargement une seule fois
          if (!sessionStorage.getItem('archive-reload-attempted')) {
            sessionStorage.setItem('archive-reload-attempted', 'true');
            // Recharger avec le paramètre pour que Liquid le traite
            window.location.href = window.location.href;
            return;
          } else {
            // Si déjà rechargé, charger le contenu via AJAX ou afficher un message
            sessionStorage.removeItem('archive-reload-attempted');
            this.loadArchiveDetail(productHandle);
          }
        }
      }
    }
  }

  async loadArchiveDetail(productHandle) {
    // Charger la page avec le paramètre pour obtenir le HTML
    try {
      const response = await fetch(`/pages/archive?product=${productHandle}`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const detailContent = doc.querySelector('.archive-detail-page');
      
      if (detailContent) {
        // Remplacer le contenu de la liste par le détail
        const archiveList = document.querySelector('.archive-page');
        if (archiveList) {
          archiveList.outerHTML = detailContent.outerHTML;
        }
      }
    } catch (error) {
      console.error('Error loading archive detail:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
  
  const productForms = document.querySelectorAll('#product-form');
  productForms.forEach(form => {
    new ProductForm(form);
  });

  new ArchiveRouter();
});

